import FancyPaper from "../components/FancyPaper";

const PendingOrders = () => {
  return (
    <FancyPaper pagetitle="Ordenes pendientes">Ordenes pendientes</FancyPaper>
  );
};

export default PendingOrders;
